import { format, parseUrlDate } from '../utils/date/dateUtils';
import { urlUtils } from '../utils/url';

const flightOnlyModel = {
  get sessionId() {
    return urlUtils.getSessionIdFromUrl();
  },
  get adults() {
    return urlUtils.getAdultsFromUrl();
  },
  get childrenAges() {
    return urlUtils.getChildrenAgesFromUrl();
  },
  get departureAirportId() {
    return urlUtils.getDepartureIdFromUrl();
  },
  get destinationAirportId() {
    return urlUtils.getDestinationAirportIdFromUrl();
  },
  // **Guard the raw value before parsing, and check validity after.** Both getters used to
  // parse first (with date-fns, at the time) and then test `!(d instanceof Date) || Number.isNaN(d)`,
  // which can never fire: that `parse` always returned a Date, and `Number.isNaN` does not coerce,
  // so `Number.isNaN(date)` was always false. An absent parameter therefore reached `format` as an
  // Invalid Date and threw `RangeError: Invalid time value`. That is what broke the flight-details
  // modal on the stopover summary, whose url carries no `QueryRetDate` — see Bug 176042.
  //
  // Every other model in `src/client/models` already guards the raw value this way. The
  // `instanceof Date` check is the belt-and-braces half they do not have: `parseUrlDate` returns
  // the string 'invalid date' for a parameter that is present but unparseable, and `format` throws
  // on that, so a raw-value check alone is not enough.
  //
  // The empty string is deliberate: `Uri`'s `createQuery` drops falsy values, so the parameter
  // is omitted from the request rather than sent blank.
  get departureDate() {
    const departureDateFromUrl = urlUtils.getDepartureDateFromUrl();
    if (!departureDateFromUrl) {
      return '';
    }

    const departureDate = parseUrlDate(departureDateFromUrl);
    return departureDate instanceof Date ? format(departureDate, '-') : '';
  },
  get returnDate() {
    const returnDateFromUrl = urlUtils.getReturnDateFromUrl();
    if (!returnDateFromUrl) {
      return '';
    }

    const returnDate = parseUrlDate(returnDateFromUrl);
    return returnDate instanceof Date ? format(returnDate, '-') : '';
  },
  get cabinClass() {
    return urlUtils.getCabinClassFromUrl();
  },
};

export default flightOnlyModel;
